(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ezy-cart"]) return;
  try {
    
  // Quantity stepper. The cart only changes when the form posts, so a click
  // updates the number at once and posts after a short pause: three quick taps
  // on + are one reload, not three. Typing a number posts on change.
  //
  // Stock cap (owner, 2026-10-14): a line whose stock Shopify tracks cannot go past it.
  // + stops at it, and a larger typed number is set back to it; either way the notice
  // shows under the line. The page reloads to post, so a notice for a number that was
  // set back is carried over the reload in sessionStorage.
  (() => {
    const KEY = 'ezy-stock-note';
    let timer;
    const post = (input) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const form = input.form;
        form.requestSubmit(form.querySelector('button[name="update"]'));
      }, 500);
    };
    const note = (input, show, changed) => {
      input.parentElement.classList.toggle('is-capped', show);
      const box = input.closest('.ezyline__meta').querySelector('[data-ezy-stock-note]');
      if (!box) return;
      box.hidden = !show;
      if (!show) return;
      const fill = (text) => text.replace('[n]', input.dataset.ezyStock);
      const body = changed ? fill(box.dataset.set) : '';
      box.querySelector('[data-ezy-stock-title]').textContent = fill(box.dataset.title);
      box.querySelector('[data-ezy-stock-body]').textContent = body;
      const live = document.querySelector('[data-ezy-cart-live]');
      if (live) {
        live.textContent = '';
        setTimeout(() => { live.textContent = `${fill(box.dataset.title)}. ${body}`.trim(); }, 50);
      }
    };
    const stockOf = (input) => (input.dataset.ezyStock === undefined
      ? Infinity : Math.max(0, Number(input.dataset.ezyStock)));
    document.addEventListener('click', (event) => {
      const step = event.target.closest('[data-ezy-line-step]');
      if (!step) return;
      const input = step.parentElement.querySelector('.ezyline__qty');
      const now = Number(input.value) || 0;
      const want = Math.max(0, now + Number(step.dataset.ezyLineStep));
      note(input, want > stockOf(input), false);
      if (want > now && want > stockOf(input)) return; // + at the stock: nothing to add
      input.value = want;
      post(input);
    });
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches('.ezyline__qty')) return;
      const want = Math.max(0, Math.floor(Number(input.value)) || 0);
      const stock = stockOf(input);
      note(input, want > stock, want > stock && stock > 0);
      if (want > stock) {
        // Set back to the stock; never to 0, which would drop a sold-out line unasked.
        input.value = stock || input.defaultValue;
        if (input.value === input.defaultValue) return;
        try { sessionStorage.setItem(KEY, input.dataset.ezyKey); } catch (error) { /* notice just won't survive the reload */ }
      }
      post(input);
    });
    let carried = null;
    try { carried = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (error) { /* no storage */ }
    const input = carried && [...document.querySelectorAll('.ezyline__qty')]
      .find((el) => el.dataset.ezyKey === carried);
    if (input) note(input, true, true);
  })();

  // "Remove unconfirmed parts" / "Remove parts not listed" — each form carries
  // one hidden ezy-line per line it removes, and /cart/change takes one line at a time. Removing shifts
  // the remaining line numbers down, so the indices are applied highest-first.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ezy-drop-unconfirmed]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button) button.disabled = true;

    const lines = [...form.querySelectorAll('input[name="ezy-line"]')]
      .map((input) => Number(input.value))
      .sort((a, b) => b - a);

    for (const line of lines) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 }),
      });
    }
    window.location.reload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezy-collection"]) return;
  try {
    
  // Where the category bar scrolls sideways, bring the category you are in into view,
  // and show the fade and arrow on each side that has more.
  (() => {
    const bar = document.querySelector('[data-ezy-cattabs]');
    if (!bar) return;
    const wrap = bar.parentElement;
    const [prev, next] = wrap.querySelectorAll('.ezycol__tabsgo');
    const cur = bar.querySelector('[aria-current="page"]');
    if (cur && bar.scrollWidth > bar.clientWidth) {
      bar.scrollLeft += cur.getBoundingClientRect().left - bar.getBoundingClientRect().left
                        - (bar.clientWidth - cur.offsetWidth) / 2;
    }
    const update = () => {
      prev.hidden = bar.scrollLeft < 2;
      next.hidden = bar.scrollLeft > bar.scrollWidth - bar.clientWidth - 2;
      wrap.classList.toggle('is-prev', !prev.hidden);
      wrap.classList.toggle('is-next', !next.hidden);
    };
    [prev, next].forEach((btn, i) => btn.addEventListener('click', () =>
      bar.scrollBy({ left: (i ? 1 : -1) * bar.clientWidth * 0.7, behavior: 'smooth' })));
    bar.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update, { passive: true });
    update();
  })();

  // Filters apply on click, the way repco.com.au and supercheapauto.com.au do —
  // no Apply step. The submit button is NOT deleted: it is the whole mechanism
  // without JavaScript, so it stays in the markup and this script hides it only
  // once the auto-submit is actually wired up.
  (() => {
    const form = document.querySelector('form.ezyrail');
    if (!form) return;

    form.querySelector('.ezyrail__apply')?.setAttribute('hidden', '');

    let pending = false;
    const submit = () => {
      if (pending) return;
      pending = true;
      form.setAttribute('aria-busy', 'true');
      // An empty text field still submits as `name=`, which left every filtered
      // URL trailing `&filter.v.price.gte=&filter.v.price.lte=`. Disabled fields
      // are omitted from the query string, so blank the empties out first.
      form.querySelectorAll('input[type="number"], input[type="search"]').forEach((field) => {
        if (!field.value.trim()) field.disabled = true;
      });
      form.submit();
    };

    form.addEventListener('change', (event) => {
      const field = event.target;
      if (!(field instanceof HTMLElement)) return;
      // The Show more toggle is a checkbox too, and it must not navigate.
      if (field.classList.contains('ezyrail__moretick')) return;
      // Fits my caravan filters in the browser — see the script after the grid.
      if (field.hasAttribute('data-ezy-fits')) return;
      if (field.matches('input[type="checkbox"], input[type="radio"], select')) submit();
      // Number inputs fire change on blur, which is the right moment for a price
      // range — submitting per keystroke would fire on every digit.
      if (field.matches('input[type="number"]')) submit();
    });

    // Enter inside the price boxes should filter, not just blur.
    form.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('input[type="number"]')) {
        event.preventDefault();
        submit();
      }
    });
  })();

  // Facet search box, as on Repco's BRANDS group. Written by script and revealed
  // by script, so the input never appears as a control that cannot work.
  (() => {
    document.querySelectorAll('[data-ezy-facet-find]').forEach((box) => {
      const input = box.querySelector('input');
      const group = box.closest('.ezyrail__grp');
      if (!input || !group) return;
      box.removeAttribute('hidden');
      input.addEventListener('input', () => {
        const needle = input.value.trim().toLowerCase();
        group.querySelectorAll('.ezyrail__row').forEach((row) => {
          const hit = !needle || row.textContent.toLowerCase().includes(needle);
          row.classList.toggle('ezyrail__row--filtered', !hit);
        });
        // While searching, the Show more clip would hide matches further down.
        group.classList.toggle('ezyrail__grp--searching', needle.length > 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezy-enquiry"]) return;
  try {
    
  // ?sku= / ?part= come from the product page's uncertain verdict. Liquid cannot
  // see them, so the attach happens here. Marked readonly once filled, because
  // §13.2 is that the customer never retypes it.
  (() => {
    const field = document.querySelector('[data-ezy-part]');
    if (!field) return;
    const params = new URLSearchParams(window.location.search);
    const sku = params.get('sku');
    const part = params.get('part');
    if (!sku && !part) return;

    field.value = part && sku ? `${part} (${sku})` : part || sku;
    field.readOnly = true;
    document.querySelector('[data-ezy-part-help]')?.setAttribute('hidden', '');
    document.querySelector('[data-ezy-part-attached]')?.removeAttribute('hidden');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezy-header"]) return;
  try {
    
  // Chrome turns solid past the fold, matching ezytrail.com.au's .sticky state.
  // Threshold is 60px: far enough that a one-notch wheel flick does not flicker
  // it, close enough that the nav is already legible before the hero scrolls out.
  //
  // Horizon does NOT scroll the window. It sets html/body to overflow:hidden and
  // scrolls .page-wrapper instead, so a window scroll listener never fires and
  // the header would stay transparent forever. Rather than hard-code that class,
  // walk up from the content to whichever ancestor is actually scrollable, and
  // listen in the capture phase so a scroll on any descendant is still seen.
  // The fixed header's height is MEASURED, not guessed. It used to be a set of
  // hardcoded --ezy-head-h values per breakpoint, and every one of them was a
  // guess about how the nav would wrap: on a phone the row splits into icons +
  // search, the announcement bar can be dismissed, and the trust strip drops
  // out — so the real height was routinely taller than the number, and the
  // first heading on the page sat clipped behind the bar.
  //
  // On the home template the nav row deliberately floats over the hero photo,
  // so only the opaque bands above it count toward the offset — but only while
  // it is actually see-through. Below 760px the nav is solid white, and counting
  // it out hid the top of the banner behind it on phones (owner, 2026-10-09).
  (function headerOffset() {
    const head = document.querySelector('[data-ezy-head]');
    const group = document.querySelector('#header-group');
    if (!head || !group) return;
    const nav = head.querySelector('.ezyn');

    const apply = () => {
      const overlays = document.body.classList.contains('ezy-home') && nav &&
        getComputedStyle(nav).backgroundColor === 'rgba(0, 0, 0, 0)';
      const h = overlays ? head.offsetHeight - nav.offsetHeight : head.offsetHeight;
      group.style.paddingTop = Math.max(0, Math.round(h)) + 'px';
    };

    apply();
    addEventListener('resize', apply, { passive: true });
    // The announcement bar can be dismissed after first paint, and web fonts
    // change the nav's height when they swap in.
    new ResizeObserver(apply).observe(head);
  })();

  (function stickyHeader() {
    const head = document.querySelector('[data-ezy-head]');
    if (!head) return;

    const findScroller = () => {
      let node = document.querySelector('.content-for-layout') || document.body;
      while (node && node !== document.body) {
        const overflow = getComputedStyle(node).overflowY;
        if (/auto|scroll/.test(overflow) && node.scrollHeight > node.clientHeight) return node;
        node = node.parentElement;
      }
      return null;
    };

    // Which element scrolls can change after load (Horizon scrolls .page-wrapper on
    // desktop and the window on phones; a rotated tablet or a resized window crosses
    // that line), so it is looked up on every scroll rather than cached — a cached
    // answer read 0 forever and left the nav see-through over the page.
    const offset = () => {
      const scroller = findScroller();
      return Math.max(window.scrollY || 0, scroller ? scroller.scrollTop : 0);
    };
    const apply = () => head.classList.toggle('ezyhead--stuck', offset() > 60);

    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply, { passive: true });
    document.addEventListener('scroll', apply, { capture: true, passive: true });
    apply();
  })();

  document.addEventListener('click', (event) => {
    const dismiss = event.target.closest('[data-ezy-announce-dismiss]');
    if (dismiss) {
      const bar = dismiss.closest('[data-ezy-announce]');
      try { localStorage.setItem('ezy-announce-dismissed', bar.dataset.key); } catch (error) { /* ignore */ }
      document.documentElement.classList.add('ezy-announce-off');
      return;
    }

    const toggle = event.target.closest('[data-ezy-menu-toggle]');
    if (toggle) {
      const drawer = document.querySelector('[data-ezy-menu]');
      if (drawer) {
        const open = drawer.hasAttribute('hidden');
        const head = document.querySelector('.ezyhead');
        if (head) drawer.style.setProperty('--ezy-head-h', head.getBoundingClientRect().bottom + 'px');
        drawer.toggleAttribute('hidden', !open);
        document.body.classList.toggle('ezy-menu-open', open);
        document.querySelectorAll('[data-ezy-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
      }
      return;
    }
    const clearBtn = event.target.closest('[data-ezy-clear]');
    if (clearBtn) {
      // Always reload, and say so immediately. Clearing changes the verdict on
      // every card, the header item and the rail — only the server can
      // recompute those. The previous version reopened the dialog instead,
      // which did nothing visible when Clear was pressed from inside the dialog
      // it was already in, so it read as a long delay rather than as an action.
      window.ezyTrack?.('caravan_cleared');
      clearBtn.disabled = true;
      clearBtn.setAttribute('aria-busy', 'true');
      setCaravan('').then(() => { window.location.reload(); });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = document.querySelector('[data-ezy-menu]');
    if (drawer && !drawer.hasAttribute('hidden')) {
      drawer.setAttribute('hidden', '');
      document.body.classList.remove('ezy-menu-open');
      document.querySelectorAll('[data-ezy-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }
  });

  // Called by snippets/ezy-caravan-steps.liquid, from the page and the dialog.
  window.ezyChooseCaravan = async (handle) => {
    window.ezyTrack?.('caravan_selected', { model: handle });
    await setCaravan(handle);
    // On a product page, stay on that part and show its fit for the new caravan.
    if (location.pathname.includes('/products/')) return location.reload();
    // Must match snippets/ezy-fit-url.liquid — see the note there.
    window.location.href =
      '/collections/all-spare-parts?fits=1';
  };

  function setCaravan(handle) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          caravan_model: handle,
          // Set when clearing, removed when a caravan is chosen. Shopify drops
          // attributes set to '', so '' here means "unset this flag".
          caravan_cleared: handle === '' ? '1' : '',
        },
      }),
    });
  }

  // One wiring pass for every picker on the page — the caravan bar's empty state
  // and the home hero card share this, so the tree is parsed once.
  (() => {
    const source = document.getElementById('ezy-tree');
    if (!source) return;
    const tree = JSON.parse(source.textContent);
    const uniq = (list) => [...new Set(list)].sort();

    document.querySelectorAll('[data-ezy-picker]').forEach((root) => {
      const series = root.querySelector('[data-ezy-series]');
      const mark = root.querySelector('[data-ezy-mark]');
      const model = root.querySelector('[data-ezy-model]');
      const go = root.querySelector('[data-ezy-go]');
      if (!series || !mark || !model || !go) return;

      const fill = (select, values) => {
        select.innerHTML = '';
        const blank = document.createElement('option');
        blank.value = '';
        blank.textContent = select.dataset.placeholder || '';
        select.appendChild(blank);
        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.appendChild(option);
        });
        select.disabled = values.length === 0;
      };

      const marksFor = (s) => uniq(tree.filter((t) => t.series === s && t.mark).map((t) => t.mark));
      const modelsFor = (s, m) =>
        tree.filter((t) => t.series === s && (m ? t.mark === m : !t.mark));

      const chosen = () => {
        const list = modelsFor(series.value, mark.value);
        return list.find((t) => t.model === model.value);
      };

      const refresh = () => {
        go.disabled = !chosen();
      };

      fill(series, uniq(tree.map((t) => t.series)));
      fill(mark, []);
      fill(model, []);
      refresh();

      series.addEventListener('change', () => {
        const marks = marksFor(series.value);
        fill(mark, marks);
        // Airlie and VZ4800 have no Mark; go straight to their models.
        fill(model, marks.length ? [] : modelsFor(series.value, '').map((t) => t.model));
        refresh();
      });

      mark.addEventListener('change', () => {
        fill(model, modelsFor(series.value, mark.value).map((t) => t.model));
        refresh();
      });

      model.addEventListener('change', refresh);

      go.addEventListener('click', async () => {
        const hit = chosen();
        if (!hit) return;
        go.disabled = true;
        await setCaravan(hit.handle);
        // Must match snippets/ezy-fit-url.liquid — see the note there.
        window.location.href =
          '/collections/all-spare-parts?fits=1';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezy-product"]) return;
  try {
    
  // Gallery: thumbnails swap the stage image. Kept to one listener because the
  // section can appear once per page.
  // Quantity stepper and the line total beside it. Formatting goes through Intl
  // with the cart's own currency rather than a hand-rolled money_format parser:
  // the price Liquid printed is the source for the initial value, and this only
  // ever has to render a multiple of it.
  const ezyRetotal = (row) => {
    const input = row.querySelector('[data-ezy-qty-input]');
    const out = row.querySelector('[data-ezy-total]');
    if (!input || !out) return;
    const qty = Math.max(1, Math.floor(Number(input.value)) || 1);
    input.value = qty;
    const cents = Number(row.dataset.ezyUnit) * qty;
    out.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: row.dataset.ezyCurrency || 'AUD', currencyDisplay: 'narrowSymbol'
    }).format(cents / 100);
  };

  // Stock cap (owner, 2026-10-14). Where the row carries the stock, what can still be
  // added is the stock less what is already in the cart: + stops there, a typed number
  // past it lights the notice, and Add / Checkout with too many stop, set the quantity
  // to the most that can be added and say so.
  const ezyStock = (row) => {
    if (!row || row.dataset.ezyStock === undefined) return null;
    const stock = Number(row.dataset.ezyStock), inCart = Number(row.dataset.ezyIncart) || 0;
    return { stock, inCart, more: Math.max(0, stock - inCart) };
  };

  // The number printed with the page can be out of date (another tab, back from the
  // cart), so it is re-read before an add is refused. Fails quietly to the old number.
  async function ezyInCart(row) {
    const id = Number(row.closest('form').querySelector('input[name="id"]').value);
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).catch(() => null);
    if (cart) row.dataset.ezyIncart = cart.items.filter((i) => i.variant_id === id)
      .reduce((n, i) => n + i.quantity, 0);
    return ezyStock(row);
  }

  // Shows (or hides) the notice under the row. `changed`: the quantity was just set
  // to the most that can be added; `message`: Shopify's own sentence, after a 422.
  function ezyCapNote(row, show, changed, message) {
    row.querySelector('.ezyqty')?.classList.toggle('is-capped', show);
    const note = row.closest('form').querySelector('[data-ezy-stock-note]');
    if (!note) return;
    note.hidden = !show;
    if (!show) return;
    const s = ezyStock(row);
    const fill = (text) => text.replace('[n]', s.stock).replace('[c]', s.inCart).replace('[m]', s.more);
    let body = '';
    if (message) body = message;
    else if (s.inCart && !s.more) body = fill(note.dataset.allInCart);
    else if (s.inCart) body = fill(note.dataset.inCart);
    else if (changed) body = fill(note.dataset.set);
    note.querySelector('[data-ezy-stock-title]').textContent = fill(note.dataset.title);
    note.querySelector('[data-ezy-stock-body]').textContent = body;
    const live = document.querySelector('[data-ezy-toast-live]');
    if (live) {
      live.textContent = '';
      setTimeout(() => { live.textContent = `${fill(note.dataset.title)}. ${body}`.trim(); }, 50);
    }
  }

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-ezy-qty-input]');
    if (!input) return;
    const row = input.closest('.ezypd__buyrow');
    ezyRetotal(row);
    const s = ezyStock(row);
    if (s) ezyCapNote(row, Math.floor(Number(input.value)) > s.more);
  });

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-ezy-qty]');
    if (step) {
      const row = step.closest('.ezypd__buyrow');
      const input = row.querySelector('[data-ezy-qty-input]');
      const want = Math.max(1, (Math.floor(Number(input.value)) || 1) + Number(step.dataset.ezyQty));
      const s = ezyStock(row);
      input.value = s ? Math.max(1, Math.min(want, s.more)) : want;
      if (s) ezyCapNote(row, want > s.more);
      ezyRetotal(row);
      return;
    }

    // The arrows beside the stage just pick the neighbouring thumbnail, so the
    // stage swap below stays the one place that changes the picture.
    const arrow = event.target.closest('[data-ezy-stage-step]');
    if (arrow) {
      const strip = [...document.querySelectorAll('[data-ezy-thumb]')];
      const at = strip.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      const next = strip[(at + Number(arrow.dataset.ezyStageStep) + strip.length) % strip.length];
      if (next) next.click();
      return;
    }

    const thumb = event.target.closest('[data-ezy-thumb]');
    if (thumb) {
      const stage = document.getElementById('ezy-stage');
      if (stage) {
        stage.removeAttribute('srcset');
        stage.src = thumb.dataset.ezyThumb;
      }
      thumb.closest('[role="tablist"]').querySelectorAll('[data-ezy-thumb]').forEach((other) => {
        other.setAttribute('aria-selected', String(other === thumb));
      });
      return;
    }

    const tab = event.target.closest('[data-ezy-tab]');
    if (tab) {
      const strip = tab.closest('[role="tablist"]');
      strip.querySelectorAll('[data-ezy-tab]').forEach((other) => {
        const on = other === tab;
        other.setAttribute('aria-selected', String(on));
        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.toggleAttribute('hidden', !on);
      });
      return;
    }

    const add = event.target.closest('[data-ezy-bundle-add]');
    if (add) addBundle(add);
  });

  function bundleTotal(scope) {
    const base = Number(scope.dataset.basePrice || 0);
    const picked = [...scope.querySelectorAll('[data-ezy-bundle-item]:checked')]
      .reduce((sum, box) => sum + Number(box.dataset.price || 0), 0);
    return base + picked;
  }

  document.addEventListener('change', (event) => {
    const box = event.target.closest('[data-ezy-bundle-item]');
    if (!box) return;
    const scope = box.closest('[data-ezy-bundle]');
    const label = scope.querySelector('[data-ezy-bundle-total]');
    const cents = bundleTotal(scope);
    label.textContent = new Intl.NumberFormat('en-AU', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'AUD',
    }).format(cents / 100);
  });

  async function addBundle(button) {
    const scope = button.closest('[data-ezy-bundle]');
    const picked = [...scope.querySelectorAll('[data-ezy-bundle-item]:checked')]
      .map((box) => ({ id: Number(box.value), quantity: 1 }));
    const items = [{ id: Number(button.dataset.self), quantity: 1 }, ...picked];
    button.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await ezyCartJson(res);
      const names = (data.items || []).map((item) => item.product_title);
      await ezyAdded(names.length > 1 ? `${names[0]} + ${names.length - 1} more` : names[0] || '',
        document.getElementById('ezy-stage'));
    } catch (error) {
      ezyToast(null, error.shopifyMessage);
    } finally {
      button.disabled = false;
    }
  }

  // Parses a cart API response. Only Shopify's own 422 sentence ("All 3 Fan are
  // in your cart.") is shown to the shopper; a network or server failure falls
  // back to the generic message instead of leaking "Failed to fetch".
  async function ezyCartJson(res) {
    const data = await res.json().catch(() => ({}));
    if (res.ok) return data;
    const error = new Error('cart add failed');
    if (res.status === 422) error.shopifyMessage = data.description || data.message || '';
    throw error;
  }

  // Add to Cart without leaving the page. Checkout is the same add, then /cart.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.ezypd__buy');
    if (!form) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    const submitter = event.submitter || form.querySelector('.ezypd__add');
    const toCart = submitter.hasAttribute('data-ezy-checkout');
    const qty = Number(new FormData(form).get('quantity')) || 1;
    const row = form.querySelector('.ezypd__buyrow');
    form.setAttribute('aria-busy', 'true');
    submitter.classList.add('is-loading');
    let leaving = false;
    try {
      let s = ezyStock(row);
      if (s && qty > s.more) s = await ezyInCart(row);
      if (s && qty > s.more) {
        if (s.more) form.querySelector('[data-ezy-qty-input]').value = s.more;
        ezyCapNote(row, true, s.more > 0);
        return;
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form),
      });
      const data = await ezyCartJson(res);
      if (s) {
        row.dataset.ezyIncart = data.quantity; // the line's new total
        ezyCapNote(row, false);
      }
      if (toCart) {
        // Stay busy until /cart loads, or a second tap would add the part again.
        leaving = true;
        window.location.href = '/cart';
        return;
      }
      submitter.classList.remove('is-loading');
      // data.quantity is the line's new total in the cart, not what was just added.
      await ezyAdded(`${data.product_title} × ${qty}`, document.getElementById('ezy-stage'));
      const button = form.querySelector('.ezypd__add');
      if (button) {
        // The original label is kept once: a second add inside the 1.8 s window
        // would otherwise save the "Added" markup as the label to restore.
        button.dataset.label = button.dataset.label || button.innerHTML;
        clearTimeout(button.ezyTimer);
        button.classList.add('is-added');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" '
          + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'
          + button.dataset.addedLabel;
        button.ezyTimer = setTimeout(() => {
          button.classList.remove('is-added');
          button.innerHTML = button.dataset.label;
        }, 1800);
      }
    } catch (error) {
      if (error.shopifyMessage && ezyStock(row)) {
        // A 422 here is a capped add, not a failure: Shopify added what it had
        // ("Only 2 items were added to your cart due to availability."), so the
        // badge and the notice follow the cart.
        await ezyInCart(row);
        ezyFlyAndCount(null).catch(() => {});
        ezyCapNote(row, true, false, error.shopifyMessage);
      } else {
        ezyToast(null, error.shopifyMessage);
      }
    } finally {
      if (!leaving) {
        submitter.classList.remove('is-loading');
        form.removeAttribute('aria-busy');
      }
    }
  });

  // Back from /cart can bring this page out of the back-forward cache still busy,
  // with the Checkout spinner turning and both buttons dead.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.ezypd__buy').forEach((form) => {
      form.removeAttribute('aria-busy');
      form.querySelectorAll('.is-loading').forEach((button) => button.classList.remove('is-loading'));
      const row = form.querySelector('.ezypd__buyrow');
      if (ezyStock(row)) ezyInCart(row); // the cart may have changed meanwhile
    });
  });

  const ezyReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // The header cart icon that is actually on screen (the header has more than one layout).
  const ezyCartIcon = () => [...document.querySelectorAll('.ezyn__cart')]
    .find((el) => el.getClientRects().length > 0);

  // A copy of the product photo arcs into the header cart, then the badge
  // takes the new count with a small bump and the corner notice appears.
  async function ezyAdded(itemText, image) {
    // The add has already succeeded by now; nothing below may turn that into an
    // error notice, so the cart read and the animation fail quietly.
    try {
      await ezyFlyAndCount(image);
    } catch (error) { /* badge stays as it was; the item is in the cart */ }
    ezyToast(itemText, null, image);
  }

  async function ezyFlyAndCount(image) {
    // Fetched alongside the flight rather than before it, so the image leaves
    // the moment the add succeeds.
    const cartReady = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const icon = ezyCartIcon();
    if (icon && image && !ezyReduced()) {
      const from = image.getBoundingClientRect();
      const to = icon.getBoundingClientRect();
      const size = Math.min(from.width, from.height, 160);
      const ghost = image.cloneNode();
      ghost.removeAttribute('id');
      Object.assign(ghost.style, {
        position: 'fixed', zIndex: 1001, pointerEvents: 'none', objectFit: 'contain', margin: 0,
        left: `${from.left + (from.width - size) / 2}px`, top: `${from.top + (from.height - size) / 2}px`,
        width: `${size}px`, height: `${size}px`, borderRadius: '12px', background: '#fff',
        boxShadow: '0 10px 30px rgba(25,20,21,.18)',
      });
      document.body.appendChild(ghost);
      const dx = to.left + to.width / 2 - (from.left + from.width / 2);
      const dy = to.top + to.height / 2 - (from.top + from.height / 2);
      await ghost.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.55}px, ${dy * 0.55 - 60}px) scale(.55)`, opacity: 0.9, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(.08)`, opacity: 0.4 },
      ], { duration: 750, easing: 'cubic-bezier(.45,.05,.55,.95)' }).finished.catch(() => {});
      ghost.remove();
    }
    const cart = await cartReady;
    document.querySelectorAll('.ezyn__cart').forEach((link) => {
      let badge = link.querySelector('.ezyn__badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ezyn__badge';
        link.appendChild(badge);
      }
      badge.textContent = cart.item_count;
      link.setAttribute('aria-label', (link.getAttribute('aria-label') || '').replace(/[0-9]+/, cart.item_count));
      if (!ezyReduced()) {
        badge.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.6)' }, { transform: 'scale(1)' }],
          { duration: 450, easing: 'ease-out' });
        link.animate([{ transform: 'rotate(0)' }, { transform: 'rotate(-12deg)' }, { transform: 'rotate(8deg)' },
          { transform: 'rotate(0)' }], { duration: 450 });
      }
    });
  }

  let ezyToastTimer = null;
  function ezyToast(itemText, errorText, image) {
    const toast = document.querySelector('[data-ezy-toast]');
    if (!toast) return;
    const msg = toast.querySelector('[data-ezy-toast-msg]');
    msg.dataset.ok = msg.dataset.ok || msg.textContent.trim();
    const isError = itemText === null;
    toast.classList.toggle('is-error', isError);
    // The gallery photo is already loaded, so the thumbnail costs no request.
    const src = image && (image.currentSrc || image.src);
    if (src) toast.querySelector('[data-ezy-toast-img]').src = src;
    toast.classList.toggle('is-noimg', !isError && !src);
    msg.textContent = isError ? (errorText || toast.dataset.failed) : msg.dataset.ok;
    toast.querySelector('[data-ezy-toast-item]').textContent = isError ? '' : itemText;
    // Below the header while it is on screen, so the cart icon the image just
    // flew into stays visible; pinned to the top once the header scrolls away.
    const head = document.querySelector('.ezyhead');
    if (window.matchMedia('(min-width: 761px)').matches) {
      const bottom = head ? head.getBoundingClientRect().bottom : 0;
      toast.style.top = `${Math.max(18, bottom + 10)}px`;
    } else {
      toast.style.top = '';
    }
    toast.hidden = false;
    // Restart the entrance animation when a second add lands on an open notice.
    toast.style.animation = 'none';
    void toast.offsetWidth;
    toast.style.animation = '';
    const live = document.querySelector('[data-ezy-toast-live]');
    if (live) {
      // Cleared first so the same sentence twice in a row is still announced.
      live.textContent = '';
      setTimeout(() => { live.textContent = `${msg.textContent} ${isError ? '' : itemText}`.trim(); }, 50);
    }
    ezyToastArm(toast);
  }

  // Auto-hides after 5 s, but never while the pointer or keyboard focus is on
  // it — it holds the View cart link.
  function ezyToastArm(toast) {
    clearTimeout(ezyToastTimer);
    if (toast.matches(':hover, :focus-within')) return;
    ezyToastTimer = setTimeout(() => { toast.hidden = true; }, 5000);
  }

  ['mouseenter', 'focusin'].forEach((type) => document.addEventListener(type, (event) => {
    if (event.target instanceof Element && event.target.matches('[data-ezy-toast]')) clearTimeout(ezyToastTimer);
    else if (type === 'focusin' && event.target instanceof Element && event.target.closest('[data-ezy-toast]')) clearTimeout(ezyToastTimer);
  }, true));
  ['mouseleave', 'focusout'].forEach((type) => document.addEventListener(type, (event) => {
    const toast = event.target instanceof Element && event.target.closest('[data-ezy-toast]');
    if (toast && !toast.hidden) setTimeout(() => ezyToastArm(toast), 0);
  }, true));

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-ezy-toast-close]');
    if (!close) return;
    clearTimeout(ezyToastTimer);
    close.closest('[data-ezy-toast]').hidden = true;
  });

  // Lightbox: zoom + pan, matched to Bunnings. One image at a time; the zoom is
  // a transform on that image and the pan is clamped so the picture can never be
  // dragged out of its own frame.
  (() => {
    const dialog = document.querySelector('[data-ezy-lightbox]');
    const opener = document.querySelector('[data-ezy-zoom]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') return;

    const stage = dialog.querySelector('[data-ezy-lb-stage]');
    const img   = dialog.querySelector('[data-ezy-lb-img]');
    const thumbs = [...dialog.querySelectorAll('[data-ezy-lb-go]')];
    const count = dialog.querySelector('[data-ezy-lb-count]');
    const zin   = dialog.querySelector('[data-ezy-lb-in]');
    const zout  = dialog.querySelector('[data-ezy-lb-out]');
    const sources = thumbs.length ? thumbs.map((t) => t.dataset.full) : [img.src];

    const MIN = 1, MAX = 4, STEP = 0.6;
    let index = 0, scale = 1, tx = 0, ty = 0;

    // Pan is clamped to the slack between the scaled picture and its frame, so
    // there is never empty space beside a zoomed image.
    const clamp = () => {
      const box = stage.getBoundingClientRect();
      const w = img.offsetWidth * scale, h = img.offsetHeight * scale;
      const maxX = Math.max(0, (w - box.width) / 2);
      const maxY = Math.max(0, (h - box.height) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    };
    const apply = () => {
      clamp();
      img.style.transform = `translate(calc(-50% + ${tx}px), calc(-50% + ${ty}px)) scale(${scale})`;
      stage.toggleAttribute('data-zoomed', scale > 1);
      if (zin)  zin.disabled  = scale >= MAX - 0.001;
      if (zout) zout.disabled = scale <= MIN + 0.001;
    };
    const setZoom = (next) => { scale = Math.min(MAX, Math.max(MIN, next)); if (scale === 1) { tx = 0; ty = 0; } apply(); };

    const show = (n) => {
      index = (n + sources.length) % sources.length;
      img.src = sources[index];
      scale = 1; tx = 0; ty = 0; apply();
      thumbs.forEach((t, i) => t.setAttribute('aria-selected', String(i === index)));
      if (count) count.textContent = `${index + 1}/${sources.length}`;
      const active = thumbs[index];
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    // The image is centred by transform rather than by the grid so that scale
    // and translate compose on one element instead of fighting place-items.
    img.style.position = 'absolute';
    img.style.left = '50%';
    img.style.top = '50%';
    img.style.transformOrigin = 'center';

    opener.addEventListener('click', () => {
      const picked = document.querySelector('[data-ezy-thumb][aria-selected="true"]');
      const at = picked ? [...document.querySelectorAll('[data-ezy-thumb]')].indexOf(picked) : 0;
      dialog.showModal();
      requestAnimationFrame(() => show(at < 0 ? 0 : at));
    });

    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-ezy-lb-close]')) { dialog.close(); return; }
      if (event.target.closest('[data-ezy-lb-prev]'))  { show(index - 1); return; }
      if (event.target.closest('[data-ezy-lb-next]'))  { show(index + 1); return; }
      if (event.target.closest('[data-ezy-lb-in]'))    { setZoom(scale + STEP); return; }
      if (event.target.closest('[data-ezy-lb-out]'))   { setZoom(scale - STEP); return; }
      const t = event.target.closest('[data-ezy-lb-go]');
      if (t) { show(Number(t.dataset.ezyLbGo)); return; }
      // Only the surround closes. Dragging the picture must never close it.
      if (!event.target.closest('.ezylb__stage, .ezylb__side')) dialog.close();
    });

    // Wheel zooms toward the pointer, which is what every image viewer does.
    stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      const box = stage.getBoundingClientRect();
      const px = event.clientX - box.left - box.width / 2 - tx;
      const py = event.clientY - box.top - box.height / 2 - ty;
      const before = scale;
      const next = Math.min(MAX, Math.max(MIN, scale - Math.sign(event.deltaY) * 0.25));
      if (next === before) return;
      const k = next / before;
      tx -= px * (k - 1);
      ty -= py * (k - 1);
      scale = next;
      apply();
    }, { passive: false });

    // Double click toggles between fit and 2x.
    stage.addEventListener('dblclick', () => setZoom(scale > 1 ? 1 : 2));

    // One finger (or the mouse) pans a zoomed image. Two fingers pinch — the
    // zoom gesture a phone user reaches for before any button (owner,
    // 2026-10-09). The pinch scales about the midpoint of the two fingers, so
    // the spot between them stays put, and moving both fingers pans.
    const fingers = new Map();
    let dragging = false, sx = 0, sy = 0, ox = 0, oy = 0, pinch = null;
    const mid = () => {
      const [a, b] = [...fingers.values()];
      return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, d: Math.hypot(a.x - b.x, a.y - b.y) };
    };
    stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') {
        fingers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        try { stage.setPointerCapture(event.pointerId); } catch (e) { /* pointer already gone */ }
        if (fingers.size === 2) {
          dragging = false;
          stage.removeAttribute('data-dragging');
          const m = mid();
          pinch = { d0: m.d, s0: scale, x0: m.x, y0: m.y, tx0: tx, ty0: ty };
          return;
        }
      }
      if (scale <= 1 || event.button !== 0) return;
      dragging = true; sx = event.clientX; sy = event.clientY; ox = tx; oy = ty;
      stage.setAttribute('data-dragging', '');
      stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (fingers.has(event.pointerId)) fingers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pinch && fingers.size === 2) {
        const m = mid();
        const box = stage.getBoundingClientRect();
        const next = Math.min(MAX, Math.max(MIN, pinch.s0 * (m.d / pinch.d0)));
        const k = next / pinch.s0;
        // Where the fingers started, measured from the picture's centre.
        const px = pinch.x0 - box.left - box.width / 2 - pinch.tx0;
        const py = pinch.y0 - box.top - box.height / 2 - pinch.ty0;
        tx = pinch.tx0 - px * (k - 1) + (m.x - pinch.x0);
        ty = pinch.ty0 - py * (k - 1) + (m.y - pinch.y0);
        scale = next;
        apply();
        return;
      }
      if (!dragging) return;
      tx = ox + (event.clientX - sx);
      ty = oy + (event.clientY - sy);
      apply();
    });
    const stop = (event) => {
      fingers.delete(event.pointerId);
      if (fingers.size < 2) pinch = null;
      if (!dragging) return;
      dragging = false;
      stage.removeAttribute('data-dragging');
      if (stage.hasPointerCapture?.(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    };
    stage.addEventListener('pointerup', stop);
    stage.addEventListener('pointercancel', stop);

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      if (event.key === 'ArrowLeft')  { event.preventDefault(); show(index - 1); }
      if (event.key === '+' || event.key === '=') { event.preventDefault(); setZoom(scale + STEP); }
      if (event.key === '-') { event.preventDefault(); setZoom(scale - STEP); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezy-search"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-ezy-filter]');
    if (!chip) return;
    const group = chip.closest('[data-ezy-chips]');
    const scope = group.parentElement.querySelector('[data-ezy-results]');
    const want = chip.dataset.ezyFilter;

    group.querySelectorAll('[data-ezy-filter]').forEach((other) => {
      other.setAttribute('aria-pressed', String(other === chip));
    });
    scope.querySelectorAll('[data-ezy-row]').forEach((row) => {
      const show = want === 'all' || row.dataset.ezyRow === want;
      row.classList.toggle('ezyrow--hidden', !show);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezy-support"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.ezysup');
    if (!root) return;
    root.classList.add('ezysup--js');
    const tiles = [...root.querySelectorAll('[data-ezy-topic]')];
    const open = (id, scroll) => {
      root.querySelectorAll('[data-ezy-policy]').forEach((s) => s.classList.toggle('is-open', s.id === id));
      tiles.forEach((t) => t.setAttribute('aria-expanded', String(t.dataset.ezyTopic === id)));
      const sec = id && document.getElementById(id);
      if (sec && scroll) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    tiles.forEach((t) => t.addEventListener('click', (e) => {
      e.preventDefault();
      const id = t.dataset.ezyTopic;
      const already = t.getAttribute('aria-expanded') === 'true';
      open(already ? null : id, !already);
      history.replaceState(null, '', already ? location.pathname : '#' + id);
    }));
    if (location.hash && document.getElementById(location.hash.slice(1))?.hasAttribute('data-ezy-policy')) {
      open(location.hash.slice(1), true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
